import '../webpackPublicPath';
import { startup } from '../startup';
import { embedIframe } from './embedIframe';
startup('embedIframe', null, embedIframe);
